module.exports = __webpack_public_path__ + "static/media/louis1.eb9f5015.mp3";